'use strict';

var template      = require('../templates/AddressModal.html');
var ModalFormView = require('commons/views/ModalForm');

module.exports = ModalFormView.extend({
    initialize: function(options) {
        ModalFormView.prototype.initialize.apply(this, [_.extend(options, {
            template: template
        })]);
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/AddressModal.js